import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ClientForm from '../../../components/forms/ClientForm';
import { useClientApi } from '../../../hooks/useClientApi';
import { useNavigate } from 'react-router-dom';
import { ClientDTO } from '../../../services/apiClient';

const ClientCreate: React.FC = () => {
  const { create, isLoading } = useClientApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Clients', href: '/admin/clients' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ClientDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/clients');
    } catch (error) {
      console.error('Error creating Client:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/clients"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Client.Edit'
    >
        <ClientForm
          initialValues={{} as ClientDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/clients')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default ClientCreate;